import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { CreateTransitProgramDriverDialogComponent } from './create-transit-program-driver-dialog.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [CommonModule, FormsModule, MatDialogModule, MatSelectModule, MatInputModule, MatButtonModule],
  exports: [CreateTransitProgramDriverDialogComponent],
  declarations: [CreateTransitProgramDriverDialogComponent]
})
export class CreateTransitProgramDialogModule {}
